export default {
    // 嘿嘿 全局的没法用
}
